import React from 'react';
import { styled, IconButton } from '@mui/material';

const IconButtonWrapper = ({ href, component = 'a', children, ...rest }) => (
  <StyledIconButton component={component} target='_blank' href={href} {...rest}>
    {children}
  </StyledIconButton>
);

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  '&:hover': { backgroundColor: theme.palette.secondary.tint },
  '& .MuiTouchRipple-root': { color: theme.palette.secondary.main },
}));

export default IconButtonWrapper;
